module.exports = __webpack_public_path__ + "static/media/legal_logo.399c2514.png";